import {
	type CherryBankControllerV6Api,
	type DashboardControllerGetEquitiesGeographyEnum,
	CherryBankControllerV6ApiFactory,
} from "@eu.mdotm.api/sphere";
import { getApiGen } from "$root/api/factory";
import { repositoryHelperFactory } from "$root/api/repository";
import { axiosExtract } from "$root/third-party-integrations/axios";

const { newQuery } = repositoryHelperFactory("customOutlookBlock");
const cherryBankApi = () => getApiGen(CherryBankControllerV6ApiFactory);

export const customOutlookBlockRepository = {
	getEquitiesTimeSeriesContinuous: newQuery(
		"getEquitiesTimeSeriesContinuous",
		(opts: {
			geography: Parameters<CherryBankControllerV6Api["dashboardControllerGetEquitiesTimeSeriesContinuous"]>[0];
			fromTime: Parameters<CherryBankControllerV6Api["dashboardControllerGetEquitiesTimeSeriesContinuous"]>[1];
		}) =>
			axiosExtract(cherryBankApi().dashboardControllerGetEquitiesTimeSeriesContinuous(opts.geography, opts.fromTime)),
	),
	getFiiContinuousTimeSeries: newQuery(
		"getFiiContinuousTimeSeries",
		(opts: { fromTime: Parameters<CherryBankControllerV6Api["dashboardControllerGetFiiContinuousTimeSeries"]>[0] }) =>
			axiosExtract(cherryBankApi().dashboardControllerGetFiiContinuousTimeSeries(opts.fromTime)),
	),
	getSectorContinuousTimeSeries: newQuery(
		"getSectorContinuousTimeSeries",
		(opts: {
			fromTime: Parameters<CherryBankControllerV6Api["dashboardControllerGetSectorContinuousTimeSeries"]>[0];
		}) => axiosExtract(cherryBankApi().dashboardControllerGetSectorContinuousTimeSeries(opts.fromTime)),
	),

	dashboardControllerGetEquities: newQuery(
		"dashboardControllerGetEquities",
		(geography?: DashboardControllerGetEquitiesGeographyEnum) =>
			axiosExtract(cherryBankApi().dashboardControllerGetEquities(geography)),
	),
	dashboardControllerGetFii: newQuery("dashboardControllerGetFii", () =>
		axiosExtract(cherryBankApi().dashboardControllerGetFii()),
	),
	dashboardControllerGetSector: newQuery("dashboardControllerGetSector", () =>
		axiosExtract(cherryBankApi().dashboardControllerGetSector()),
	),
};
